import React from 'react';

import { MemberList } from '@components/admin/members/MemberList';

export const CompletionRequests: React.FC = () => <MemberList type="completionRequests" />;
